import { createSimpleSelector } from '../redux'

const kioskSettingsSelector = createSimpleSelector(
  state => state.entities.kioskSettings
)

export const isFetchingGetKioskSettings = kioskSettingsSelector.isFetching
export const getDataGetKioskSettings = kioskSettingsSelector.getData
export const getErrorGetKioskSettings = kioskSettingsSelector.getError
